module.exports = __webpack_public_path__ + "static/media/welcome.24544e50.jfif";